// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 850) return "static/chunks/850-9c2beb6ab4574ab7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"175":"f6451dcc2a687c69","632":"1c91e8ee05ae0cb1","741":"6ba092fa8ddae048"}[chunkId] + ".js";
};